module.exports = __webpack_public_path__ + "static/media/eye.88779e7c.png";